export default __webpack_public_path__ + "static/carbon-25197e032661ead468bd04c7572b480d.jpg";